import {
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useUser } from "../../../globals/UserContext";
import { useClass } from "../../../globals/ClassContext";
import axios from "axios";
import { useSetAssignmentReview } from "../../../globals/AssignmentReviewContext";

const { REACT_APP_DEBUGGER_SERVER_URL } = process.env;

export default function Window({ setPage }) {
  const user = useUser();
  const classroom = useClass();
  const assignments = classroom.assignments;
  const assignmentAttempts = user.assignment_attempts;
  const setAssignmentReview = useSetAssignmentReview();

  const [grades, setGrades] = useState([]);

  //We need to look at all the assignments for the class, make sure the attempts belong to this class

  useEffect(() => {
    if (assignments) {
      const completedAttempts = assignmentAttempts.filter((attempt) => {
        return (
          attempt.isCompleted === true &&
          assignments.includes(attempt.assignment)
        );
      });
      if (completedAttempts && completedAttempts.length > 0) {
        const fetchData = async () => {
          const requests = assignments.map((attempt) =>
            axios.get(`${REACT_APP_DEBUGGER_SERVER_URL}/assignment/${attempt}`)
          );
          const responses = await axios.all(requests);
          const data = responses.map((response) => response.data);
          completedAttempts.forEach((attempt) => {
            const result = data.find((obj) => obj._id === attempt.assignment);
            attempt.name = result.name;
            attempt.maxPoints = result.points;
          });

          data.forEach((assignment) => {
            //check if we have a grade for this assignment already
            const result = completedAttempts.find(
              (obj) => obj.assignment === assignment._id
            );
            if (!result) {
              //now lets check if this assignment is overdue, if it is we display a grade, if not then continue hiding it
              const assignmentDueDate = new Date(assignment.due_date);
              const today = new Date();
              if (today > assignmentDueDate) {
                const attempt = assignmentAttempts.find(
                  (obj) => obj.assignment === assignment._id
                );
                let grade = attempt?.pointsEarned;
                if (isNaN(grade)) {
                  grade = 0;
                }
                const classGrade = {
                  _id: assignment._id,
                  name: assignment.name,
                  pointsEarned: grade,
                  maxPoints: assignment.points,
                };
                completedAttempts.push(classGrade);
              }
            }
          });
          //create our class grade object
          let totalPointsEarned = 0;
          let maxTotalPoints = 0;
          completedAttempts.forEach((grade) => {
            totalPointsEarned += grade.pointsEarned;
            maxTotalPoints += grade.maxPoints;
          });
          const classGrade = {
            _id: "classGrade",
            name: "Total",
            pointsEarned: totalPointsEarned,
            maxPoints: maxTotalPoints,
          };

          completedAttempts.push(classGrade);

          setGrades(completedAttempts);
        };
        fetchData();
      } else {
        setGrades([]);
      }
    }
  }, [assignmentAttempts, assignments]);

  const reviewAssignment = (row) => {
    if (row.name !== "Total") {
      setAssignmentReview({
        user: user,
        assignmentID: row.assignment,
      });
      setPage("assignmentReview");
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 100 }} size="small" aria-label="Grades">
        <TableHead>
          <TableRow>
            <TableCell>Assignment Name:</TableCell>
            {/* <TableCell align="right">Date Completed:</TableCell> */}
            <TableCell align="right">Points:</TableCell>
            <TableCell align="right">Grade:</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {grades.map((row) => (
            <TableRow
              key={row.name}
              onClick={() => reviewAssignment(row)}
              sx={{ cursor: row.name !== "Total" && "pointer" }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">
                {(row.pointsEarned ? row.pointsEarned : 0) +
                  "/" +
                  row.maxPoints}
              </TableCell>
              <TableCell align="right">
                {((row.pointsEarned / row.maxPoints) * 100).toFixed(2) + "%"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
